<template>
  <div v-bind:class="this.type === 'campaign' ? 'campaign-wrap' : 'summary-wrap'">
    <iframe scrolling="no"
      v-bind:id="this.type === 'campaign' ? 'campaign-iframe_wrapper' : 'iframe_wrapper'"
      :src="createUrl(this.label)"
      :frameborder=0
    />
  </div>
</template>

<script>

import Crypto from 'crypto';
import Querystring from 'querystring';

export default {
  name: 'detail',
  components: {
  },
  props: {
    label: String,
    type: String,
    embedUrl: Number
  },
  methods: {
    nonce(length) {
      let text = '';
      const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

      for (let i = 0; i < length; i += 1) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }

      return text;
    },
    forceUnicodeEncoding(string) {
      return decodeURIComponent(encodeURIComponent(string));
    },
    createSignedEmbedUrl(options) {
      // looker options
      const { host } = options;
      const { secret } = options;

      // user options
      const jsonExternalUserId = JSON.stringify(options.externalUserId);
      const jsonPermissions = JSON.stringify(options.permissions);
      const jsonModels = JSON.stringify(options.models);
      const jsonAcessFilters = JSON.stringify(options.accessFilters);

      // url/session specific options
      const embedPath = `/login/embed/${encodeURIComponent(options.embedUrl)}`;
      const jsonSessionLength = JSON.stringify(options.sessionLength);
      const jsonForceLogoutLogin = JSON.stringify(options.forceLogoutLogin);

      // computed options
      const jsonTime = JSON.stringify(Math.floor((new Date()).getTime() / 1000));
      const jsonNonce = JSON.stringify(this.nonce(16));

      // compute signature
      let stringToSign = '';
      stringToSign += `${host}\n`;
      stringToSign += `${embedPath}\n`;
      stringToSign += `${jsonNonce}\n`;
      stringToSign += `${jsonTime}\n`;
      stringToSign += `${jsonSessionLength}\n`;
      stringToSign += `${jsonExternalUserId}\n`;
      stringToSign += `${jsonPermissions}\n`;
      stringToSign += `${jsonModels}\n`;
      stringToSign += jsonAcessFilters;

      const signature = Crypto.createHmac('sha1', secret).update(this.forceUnicodeEncoding(stringToSign)).digest('base64').trim();

      // construct query string
      const queryParams = {
        nonce: jsonNonce,
        time: jsonTime,
        external_user_id: jsonExternalUserId,
        permissions: jsonPermissions,
        models: jsonModels,
        access_filters: jsonAcessFilters,
        session_length: jsonSessionLength,
        force_logout_login: jsonForceLogoutLogin,
        signature,
      };

      const queryString = Querystring.stringify(queryParams);

      return `${host + embedPath}?${queryString}`;
    },
    createUrl(label) {
      let embedUrl = 'lookerembed.adelaidelift.com'

      if(window.location.hostname === 'reporting.adelaidemetrics.com') {
        embedUrl = 'looker.adelaidemetrics.com';
      }
      const urlData = {
        host: embedUrl,
        secret: process.env.VUE_APP_LOOKER_SECRET,
        externalUserId: '45',
        permissions: [
          'access_data',
          'download_without_limit',
          'see_lookml_dashboards',
          'see_user_dashboards',
        ],
        models: ['parsec','adelaide'],
        accessFilters: {},
        sessionLength: 60 * 60, // NOTE: 60min
        embedUrl: this.type === 'campaign' ? `/embed/dashboards-next/${this.embedUrl}` : `/embed/dashboards/${this.embedUrl}`,
        forceLogoutLogin: false,
      };

      const url = this.createSignedEmbedUrl(urlData);
      return `https://${url}`;
    },
  },
};
</script>

<style>

#iframe_wrapper {
  width: 100%;
  min-height: 100%;
  pointer-events: none;
}

.campaign-wrap {
  height: 100%;
  width: 100%;
}

.campaign-wrap > iframe {
  padding-bottom: 75px;
}

.summary-wrap {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}

#campaign-iframe_wrapper {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  border-radius: 5px;
  overflow: hidden;
  opacity: 0;
  transition: 0.2s opacity ease;
}

.campaign-wrap:after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  background: #f6f8fa;
  height: 105px;
  width: 100%;
  z-index: 100;
}

#campaign-iframe_wrapper.active {
  opacity: 1;
}
</style>
